<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="flex famous_position">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：学校资源库  >  <router-link to="/paper_my" class="cl_gray">试卷库</router-link>  >  创建试卷</p>
					</div>
					<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
				</div>
				<div class="found">
					<div class="found_l">
						<div class="found_l_item">
							<div class="found_l_item_l f16px cl_dark">适用年级</div>
							<div class="found_l_item_r f16px">
								<span class="cl_gray mar15">{{grade_name}}</span>
								<span class="cl_dark mal15 mar15">学科</span>
								<span class="cl_gray mal15">{{subject_name}}</span>
							</div>
						</div>
						<div class="found_l_item mat25">
							<div class="found_l_item_l f16px cl_dark mat10">设置试卷名称</div>
							<div class="found_l_item_r f16px">
								<input type="text" placeholder="请输入试卷名称" placeholer-class="placeholder" class="found_l_item_input f16px" v-model="name" />
							</div>
						</div>
						<div class="found_l_item mat25">
							<div class="found_l_item_l f16px cl_dark mat10">建议作答时长</div>
							<div class="found_l_item_r f16px">
								<input type="text" placeholder="请输入作答时长" placeholer-class="placeholder" class="found_l_item_input f16px" v-model="period" />
								<span class="cl_gray mal10">分钟</span>
							</div>
						</div>
						<div class="found_l_item mat25">
							<div class="found_l_item_l f16px cl_dark mat10">上传试卷</div>
							<div class="found_l_item_r f16px">
								<el-upload class="found_l_item_file" action="http://res.joy366.com/api/upload/post_add_pdf" :data="data" :on-remove="handleRemove"
								 :limit="1" :on-exceed="handleExceed" :on-success="handleAvatarSuccess" accept=".pdf" :file-list="fileList">
								  <el-button size="small" class="found_l_item_file_btn">点击上传</el-button>
								  <div slot="tip" class="f14px cl_gray mat10">仅支持 pdf 格式文件，其他文档请先转换为 pdf 格式</div>
								</el-upload>
							</div>
						</div>
						<div class="found_l_item mat25">
							<div class="found_l_item_l f16px cl_dark mat10">上传答案与解析</div>
							<div class="found_l_item_r f16px">
								<el-upload class="found_l_item_file" action="http://res.joy366.com/api/upload/post_add_pdf" :data="data" :on-remove="handleRemove2"
								 :limit="1" :on-exceed="handleExceed2" :on-success="handleAvatarSuccess2" accept=".pdf" :file-list="fileList2">
								  <el-button size="small" class="found_l_item_file_btn">点击上传</el-button>
								  <div slot="tip" class="f14px cl_gray mat10">仅支持 pdf 格式文件，其他文档请先转换为 pdf 格式</div>
								</el-upload>
							</div>
						</div>
						<div class="found_l_item mat25">
							<div class="found_l_item_l f16px cl_dark mat10">选择大题类型</div>
							<div class="found_l_item_r cl_gray">
								<div class="found_item_topic_cont tc">
									<div class="found_item_topic_list radius8 cur" @click="typeCheck('选择题')">+选择题</div>
									<div class="found_item_topic_list radius8 cur" @click="typeCheck('判断题')">+判断题</div>
									<div class="found_item_topic_list radius8 cur" @click="typeCheck('填空题')">+填空题</div>
									<div class="found_item_topic_list radius8 cur" @click="typeCheck('解答题')">+解答题</div>
								</div>
							</div>
						</div>
						<div class="found_l_item mat40">
							<div class="found_l_item_l f16px cl_dark mat10"></div>
							<div class="found_l_item_r">
								<button class="found_l_submit cl_white f18px" @click.stop="save">保存试卷</button>
							</div>
						</div>
					</div>
					<div class="found_r">
						<div class="f16px mab30">设置题目和答案</div>
						<div class="" v-if="list.length > 0">
							<div class="found_list" v-for="(item,index) in list" :key="index">
								<div class="found_list_title flex f16px cl_violet radius8">
									<div class="found_list_title_l">{{item.number}}、{{item.type}} ({{item.fraction_all}}分)</div>
									<img src="../../../static/close_white.png" class="found_list_title_r cur" @click="remove(index)" />
								</div>
								<div class="found_list_cont mat20">
									<div class="found_list_item flex radius8" v-for="(second,secondIndex) in item.topic" :key="secondIndex">
										<div class="found_list_item_l flex">
											<div class="found_list_item_index">{{second.id}}</div>
											<div class="found_list_item_cont flex" v-if="item.type == '选择题'">
												<div class="found_list_item_check_cont flex cl_gray tc">
													<div class="radius found_list_item_check cur" v-for="(third,thirdIndex) in second.arr" :key="thirdIndex"
													:class="{'on': third.check}" @click="check(index,secondIndex,thirdIndex)">{{third.name}}</div>
												</div>
												<div class="found_list_item_check_add tc flex f16px cl_violet">
													<div class="radius cur" @click="plusCheck(index,secondIndex)">+</div>
													<div class="radius cur" @click="reduceCheck(index,secondIndex)">-</div>
												</div>
											</div>
											<div class="found_list_item_cont flex" v-if="item.type == '判断题'">
												<div class="found_list_item_judge cl_gray cur tc" v-for="(third,thirdIndex) in second.arr" :key="thirdIndex"
												:class="{'on': third.check}" @click="judge(index,secondIndex,thirdIndex,third.check)">{{third.name}}</div>
											</div>
											<div class="found_list_item_cont" v-if="['选择题','判断题'].indexOf(item.type) < 0">
												<p class="f12px cl_gray">本小题作为主观题，不提供在线作答功能，由学生<br>在线下用纸笔作答，并自行校对答案并计算得分。</p>
											</div>
										</div>
										<div class="found_list_item_r flex">
											<div class="flex">
												<el-input-number v-model="second.fraction" controls-position="right" :min="0.5" :step="0.5" size="small"
												 class="found_dialog_item_num" @change="((currentValue, oldValue)=>{fractionCheck(index, secondIndex, currentValue, oldValue)})"></el-input-number>
												<span class="mal10">分</span>
											</div>
											<img src="../../../static/close_violet.png" class="found_list_item_close cur mal10" @click="removeOne(index,secondIndex)" />
										</div>
									</div>
								</div>
								<div class="fopund_list_btm cur tc cl_violet radius8 mat15" @click="add(index,item.type)">+新增小题</div>
							</div>
						</div>
						<div v-else class="tc">
							<img src="../../../static/paper_empty.png" class="mat50" />
							<p class="cl_gray f18px mat10">请从左侧选择大题类型</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 创建试卷 -->
		<el-dialog :title="'添加'+title" :visible.sync="dialog_show" width="25%" center>
		  <div class="f16px paper_dialog_cont">
				<div class="found_dialog_item mab30">
					<div class="found_dialog_item_l f16px cl_dark"><span class="cl_red">*</span>题目名称</div>
					<div class="found_dialog_item_r">
						<input type="text" v-model="type_name" class="found_dialog_item_input f16px" />
					</div>
				</div>
				<div class="found_dialog_item mab30">
					<div class="found_dialog_item_l f16px cl_dark">题号</div>
					<div class="found_dialog_item_r">
						<el-input-number v-model="min" controls-position="right" :min="1" size="small" class="found_dialog_item_num"></el-input-number>
						<span class="mal15 mar15">-</span>
						<el-input-number v-model="max" controls-position="right" :min="1" size="small" class="found_dialog_item_num"></el-input-number>
					</div>
				</div>
				<div class="found_dialog_item">
					<div class="found_dialog_item_l f16px cl_dark">小题分值</div>
					<div class="found_dialog_item_r">
						<el-input-number v-model="fraction" controls-position="right" :min="0.5" :step="0.5"
						 size="small" class="found_dialog_item_num"></el-input-number>
					</div>
				</div>
			</div>
		  <div slot="footer" class="f18px mab20">
		    <span @click="dialog_show = false" class="cl_violet cur inline paper_dialog_cancel">取 消</span>
		    <span @click.stop="dialogConfirm" class="cl_white cur inline paper_dialog_confirm">确 定</span>
		  </div>
		</el-dialog>
		<!-- 创建成功 -->
		<el-dialog title="" :visible.sync="success_show" width="25%" center :closeOnClickModal="false">
			<div class="f16px paper_dialog_cont tc">
				<img src="../../../static/success_green.png" />
				<p class="f20px cl_gray mat10">创建试卷成功！</p>
			</div>
			<div slot="footer" class="f18px mab20">
				<router-link to="/paper_my" replace class="cl_violet cur inline paper_dialog_cancel">查看试卷</router-link>
				<span @click="successReturn" class="cl_violet cur inline paper_dialog_cancel">继续创建</span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'class_manage',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 6,
					listCur: 2,
					open: 0,
				},
				grade_id_str: "",
				grade_name: "",
				subject_id: "",
				subject_name: "",
				is_student_show: "",
				name: "", //试卷名称
				period: "", //作答时长
				fileList: [], //上传试卷
				fileList2: [], //上传答案
				data: {
					token: localStorage.getItem("token")
				},
				ques_file: "",
				ques_file_name: "",
				answ_file: "",
				answ_file_name: "",
				dialog_show: false,
				title: "",
				type_name: "",
				fraction: 1,
				min: 1,
				max: 2,
				list: [], //题目答案列表
				success_show: false,
				id: "", //编辑试卷id
			}
		},
		created() {
			if (this.$route.query.grade_id_str) {
				this.grade_id_str = this.$route.query.grade_id_str;
				this.grade_name = this.$route.query.grade_name;
				this.subject_id = this.$route.query.subject_id;
				this.subject_name = this.$route.query.subject_name;
				this.is_student_show = this.$route.query.is_student_show;
			}
			if (this.$route.query.id) {
				this.id = this.$route.query.id;
				this.getPaper();
			}
		},
		mounted() {
			
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//试卷编辑
			getPaper () {
				this.$get("/api/teacher/get_examination_paper_show",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					this.list = res.data.card_json_arr;
					this.name = res.data.name;
					this.period = res.data.period;
					this.subject_name = res.data.subject_name;
					this.subject_id = res.data.subject_id;
					this.grade_id_str = res.data.grade_id_str;
					this.grade_name = res.data.grade_names;
					this.is_student_show = res.data.is_student_show;
					this.ques_file = res.data.ques_file;
					this.answ_file = res.data.answ_file;
					this.ques_file_name = res.data.ques_file_name;
					this.answ_file_name = res.data.answ_file_name;
					this.fileList.push({name: res.data.ques_file_name});
					this.fileList2.push({name: res.data.answ_file_name});
				});
			},
			//试卷上传
			handleRemove(file, fileList) {
				this.ques_file = "";
				this.ques_file_name = "";
			},
			handleExceed(files, fileList) {
				this.$message.warning("最多只能上传一个文件");
			},
			handleAvatarSuccess (response, file, fileList) {
				this.ques_file = response.data.file;
				this.ques_file_name = file.name;
			},
			//答案上传
			handleRemove2(file, fileList) {
				this.answ_file = "";
				this.ques_file_name = "";
			},
			handleExceed2(files, fileList) {
				this.$message.warning("最多只能上传一个文件");
			},
			handleAvatarSuccess2 (response, file, fileList) {
				this.answ_file = response.data.file;
				this.answ_file_name = file.name;
			},
			typeCheck (e) {
				this.dialog_show = true;
				this.title = e;
				this.type_name = this.title;
				this.min = 1;
				this.max = 2;
				this.fraction = 1;
			},
			//添加题型
			dialogConfirm () {
				if (this.min > this.max) {
					this.$message({
						duration: 1500,
						message: '起始序号不能大于结束序号',
						type: 'error'
					});
					return false
				}
				let fraction_all = 0;
				let topic = [];
				let arr = [];
				let id = this.list.length + 1; 
				fraction_all = (this.max - this.min + 1) * this.fraction;
				this.dialog_show = false;
				if (this.title == "选择题") {
					arr.push({id: 1, name: "A", check: false},{id: 2, name: "B", check: false},{id: 3, name: "C", check: false},{id: 4, name: "D", check: false});
					for (let i = this.min; i < this.max+1; i++) {
						topic.push({id: i, fraction: this.fraction, arr: JSON.parse(JSON.stringify(arr))});
					}
				} else if (this.title == "判断题") {
					arr.push({id: 1, name: "正确", check: false},{id: 2, name: "错误", check: false});
					for (let i = this.min; i < this.max+1; i++) {
						topic.push({id: i, fraction: this.fraction, arr: JSON.parse(JSON.stringify(arr))});
					}
				} else {
					for (let i = this.min; i < this.max+1; i++) {
						topic.push({id: i, fraction: this.fraction});
					}
				}
				this.list.push({id: id, name: this.type_name, number: this.toChinesNum(id), fraction_all: fraction_all, type: this.title, topic: topic});
				console.log(this.list)
			},
			//中文序号
			toChinesNum (num) {
				let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; 
				let unit = ["", "十", "百", "千", "万"];
				num = parseInt(num);
				let getWan = (temp) => {
					let strArr = temp.toString().split("").reverse();
					let newNum = "";
					for (var i = 0; i < strArr.length; i++) {
						newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
					}
					return newNum;
				}
				let overWan = Math.floor(num / 10000);
				let noWan = num % 10000;
				if (noWan.toString().length < 4) {
					noWan = "0" + noWan;
				}
				return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
			},
			//删除
			remove (index) {
				this.$messageBox.confirm('删除大题会连同小题一起删除，确定要删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.list.splice(index, 1);
				}).catch(() => {
					
				});
			},
			removeOne (index,secondIndex) {
				this.list[index].topic.splice(secondIndex, 1);
				this.fractionChange(index);
			},
			fractionCheck (index, secondIndex, currentValue, oldValue) {
				this.fractionChange(index);
			},
			//分数修改
			fractionChange (index) {
				let fraction_all = 0;
				for (let i = 0; i < this.list[index].topic.length; i++) {
					fraction_all += this.list[index].topic[i].fraction;
				}
				this.list[index].fraction_all = fraction_all;
			},
			//新增小题
			add (index,type) {
				var list = this.list;
				let id = 0;
				let arr = [];
				if (list[index].topic.length == 0) {
					id = 1;
				} else {
					id = list[index].topic[list[index].topic.length - 1].id + 1;
				}
				if (type == "选择题") {
					arr.push({id: 1, name: "A", check: false},{id: 2, name: "B", check: false},{id: 3, name: "C", check: false},{id: 4, name: "D", check: false});
					list[index].topic.push({id: id, fraction: this.fraction, arr: JSON.parse(JSON.stringify(arr))});
				} else if (type == "判断题") {
					arr.push({id: 1, name: "正确", check: false},{id: 2, name: "错误", check: false});
					list[index].topic.push({id: id, fraction: this.fraction, arr: JSON.parse(JSON.stringify(arr))});
				} else {
					list[index].topic.push({id: id, fraction: this.fraction});
				}
			},
			//判断题
			judge (index, secondIndex, thirdIndex, check) {
				for (let i = 0; i < this.list[index].topic[secondIndex].arr.length; i++) {
					this.list[index].topic[secondIndex].arr[i].check = false;
				}
				this.list[index].topic[secondIndex].arr[thirdIndex].check = true;
			},
			//选择题
			check(index, secondIndex, thirdIndex) {
				this.list[index].topic[secondIndex].arr[thirdIndex].check = !this.list[index].topic[secondIndex].arr[thirdIndex].check;
			},
			//选项加减
			plusCheck (index, secondIndex) {
				if (this.list[index].topic[secondIndex].arr.length >= 10) {
					this.$message({
						duration: 1500,
						message: '选项最多10个',
						type: 'warning'
					});
					return false
				} else {
					let id = this.list[index].topic[secondIndex].arr.length + 1;
					let letter = String.fromCharCode(64 + parseInt(id));
					let arr = {id: id, name: letter, check: false};
					this.list[index].topic[secondIndex].arr.push(JSON.parse(JSON.stringify(arr)));
				}
				
			},
			reduceCheck (index, secondIndex) {
				if (this.list[index].topic[secondIndex].arr.length <= 2) {
					this.$message({
						duration: 1500,
						message: '选项不能少于2个',
						type: 'warning'
					});
					return false
				} else {
					this.list[index].topic[secondIndex].arr.pop();
				}
			},
			//保存试卷
			save () {
				let card_json = [];
				if (this.name == "") {
					this.$message({
						duration: 1500,
						message: '试卷名称不能为空',
						type: 'error'
					});
					return false
				}
				if (this.period == 0) {
					this.$message({
						duration: 1500,
						message: '建议作答时长不能为0',
						type: 'error'
					});
					return false
				}
				if (this.ques_file == "") {
					this.$message({
						duration: 1500,
						message: '请上传试卷',
						type: 'error'
					});
					return false
				}
				if (this.answ_file == "") {
					this.$message({
						duration: 1500,
						message: '请上传答案与解析',
						type: 'error'
					});
					return false
				}
				if (this.list.length == 0) {
					this.$message({
						duration: 1500,
						message: '题目不能为空',
						type: 'error'
					});
					return false
				} else {
					for (let i = 0; i < this.list.length; i++) {
						if (this.list[i].type == "选择题" || this.list[i].type == "判断题") {
							for (let j = 0; j < this.list[i].topic.length; j++) {
								let len = 0;
								for (let k = 0; k < this.list[i].topic[j].arr.length; k++) {
									if (this.list[i].topic[j].arr[k].check == false) {
										len ++;
									}
								}
								if (len == this.list[i].topic[j].arr.length) {
									this.$message({
										duration: 1500,
										message: '部分客观题未设置正确答案',
										type: 'error'
									});
									return false
								}
							}
						}
					}
				}
				card_json = this.list;
				card_json = JSON.stringify(card_json);
				if (this.id != "") {
					this.$get("/api/teacher/post_examination_paper_edit",{
						token: localStorage.getItem("token"),
						subject_id: this.subject_id,
						grade_id_str: this.grade_id_str,
						is_student_show: this.is_student_show,
						name: this.name,
						period: this.period,
						ques_file: this.ques_file,
						answ_file: this.answ_file,
						ques_file_name: this.ques_file_name,
						answ_file_name: this.answ_file_name,
						card_json: card_json,
						id: this.id,
					})
					.then(res => {
						this.$message({
							duration: 1500,
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							this.$router.go(-1);
						}, 1500);
					});
				} else {
					this.$get("/api/teacher/post_examination_paper_add",{
						token: localStorage.getItem("token"),
						subject_id: this.subject_id,
						grade_id_str: this.grade_id_str,
						is_student_show: this.is_student_show,
						name: this.name,
						period: this.period,
						ques_file: this.ques_file,
						answ_file: this.answ_file,
						ques_file_name: this.ques_file_name,
						answ_file_name: this.answ_file_name,
						card_json: card_json,
					})
					.then(res => {
						this.$message({
							duration: 1500,
							message: res.msg,
							type: 'success'
						});
						this.success_show = true;
					});
				}
			},
			successReturn () {
				this.success_show = false;
				location.reload();
			},
		},
	}
</script>

<style>
</style>
